import { BookingUserProfileModel } from '../booking';
import { BaseModel, SiteBaseModel } from '../site';

export interface TelehealthAvailableRequest {
    state?: StateEnum;
    gender?: string;
    language?: string[];
}

export enum StateEnum {
    NSW = 'NSW',
    ACT = 'ACT',
    QLD = 'QLD',
    VIC = 'VIC',
    SA = 'SA',
    WA = 'WA',
    TAS = 'TAS',
    NT = 'NT',
}

export interface TelehealthAvailableModel extends BaseModel {
    siteId: number;
    stateId: number;
    userId: number;
    bpUserId: number;
    appointmentTypeId: number;
    gender?: string;
    languageMatch?: string;
    slotId: number;
    slot: string;
    slotDay: string;
    slotTime: string;
    duration: number;
    priority: number;
    minsFromNow: number;
    site: SiteBaseModel;
    user: BookingUserProfileModel;
}
